export default __webpack_public_path__ + "static/media/submitStage.3b6545f6.png";